import { render, staticRenderFns } from "./ClientsCertificatesNew.vue?vue&type=template&id=6b11a7b6&"
import script from "./ClientsCertificatesNew.vue?vue&type=script&lang=js&"
export * from "./ClientsCertificatesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports